import type { FormatMessages } from "@skilitics/localization";
import { FormattedMessage, useFormatMessage } from "@skilitics/localization";

export const NodeLinkagesWarning = ({
  associations,
  configReferences,
}: {
  associations: number[];
  configReferences: number[];
}) => {
  const formatMessage = useFormatMessage(formatStrings);
  return (
    <div>
      <h4>{formatMessage("invalidLinkages")}</h4>
      <p>
        <FormattedMessage messages={formatStrings.nodeAssociations} values={{ count: associations.length }} />
      </p>
      <p>
        <FormattedMessage messages={formatStrings.configReferences} values={{ count: configReferences.length }} />
      </p>
    </div>
  );
};

const formatStrings = {
  invalidLinkages: {
    en: "Linkages exist that would be invalidated.",
  },
  nodeAssociations: {
    en: `Node Associations: {count}`,
  },
  configReferences: {
    en: `Node Config (e.g. variable) References: {count}`,
  },
} satisfies FormatMessages;
